import { PayloadAction, createPersistReducer, initReducer } from "@grassrootly/rn-core";
import { ICompetitionView, ISeason, IPlayerSeasonStats, IGameView } from "@grassrootly/api";

export interface CompetitionsState {
  competitions: ICompetitionView[];
  seasons: { [competitionId: number]: ISeason[] };
  defaultSeasonIds: { [competitionId: number]: number | null };
  seasonStats: { [seasonId: number]: IPlayerSeasonStats[] };
  seasonMatches: { [seasonId: number]: IGameView[] };
}

const initialState: CompetitionsState = {
  competitions: [],
  seasons: {},
  defaultSeasonIds: {},
  seasonStats: {},
  seasonMatches: {},
};

const competitionsSlice = initReducer({
  name: "competitions",
  initialState,
  reducers: {
    setCompetitions: (state: CompetitionsState, action: PayloadAction<ICompetitionView[]>) => {
      state.competitions = action.payload;
    },
    setSeasons: (
      state: CompetitionsState,
      action: PayloadAction<{ competitionId: number; seasons: ISeason[]; defaultSeasonId: number | null }>
    ) => {
      const { competitionId, seasons, defaultSeasonId } = action.payload;
      state.seasons[competitionId] = seasons;
      state.defaultSeasonIds[competitionId] = defaultSeasonId;
    },
    setSeasonStats: (
      state: CompetitionsState,
      action: PayloadAction<{ seasonId: number; stats: IPlayerSeasonStats[] }>
    ) => {
      const { seasonId, stats } = action.payload;
      state.seasonStats[seasonId] = stats;
    },
    setSeasonMatches: (
      state: CompetitionsState,
      action: PayloadAction<{ seasonId: number; matches: IGameView[] }>
    ) => {
      const { seasonId, matches } = action.payload;
      state.seasonMatches[seasonId] = matches;
    },
    clearCompetitionsData: (state: CompetitionsState) => {
      state.competitions = [];
      state.seasons = {};
      state.defaultSeasonIds = {};
      state.seasonStats = {};
      state.seasonMatches = {};
    },
  },
});

export const competitionsActions = competitionsSlice.actions;
export const competitionsReducer = competitionsSlice.reducer;
